import React from "react"

class UserDataType extends React.Component {
  
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data) {
      if (this.props.data.name) {
        return (
          <span>{this.props.data.name} {this.props.data.status == 'inactive' ? <p>(<i>{I18n.t('inactive')}</i>)</p> : ''}</span>
        )
      } else if (this.props.data.first_name) {
        return (
          <span>{this.props.data.first_name + " " + this.props.data.last_name} {this.props.data.status == 'inactive' ? <p>(<i>{I18n.t('inactive')}</i>)</p> : ''}</span>
        );
      } else {
        return (
          <div><span className="none">{I18n.t('none')}</span></div>
        )
      }
    } else {
      return (
        <div><span className="none">{I18n.t('none')}</span></div>
      );
    }
  }

};

export default UserDataType